/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import type {
  PurchaseRequestPoNumberConfigurationDto,
  PurchaseRequestPoNumberConfigurationRequest,
} from '../dto'
import { ContentType, HttpClient, RequestParams } from './http-client'

export class ApiPurchaseRequestsNumberConfigurationController<SecurityDataType = unknown> {
  http: HttpClient<SecurityDataType>

  constructor(http: HttpClient<SecurityDataType>) {
    this.http = http
  }

  /**
   * No description
   *
   * @tags api-purchase-requests-number-configuration-controller
   * @name GetCurrentPoNumberConfiguration
   * @request GET:/api/v1/purchase-requests/configuration/poNumber
   */
  getCurrentPoNumberConfiguration = (params: RequestParams = {}) =>
    this.http.request<PurchaseRequestPoNumberConfigurationDto, any>({
      path: `/v1/purchase-requests/configuration/poNumber`,
      method: 'GET',
      format: 'json',
      ...params,
    })

  static getCurrentPoNumberConfigurationPath = '/v1/purchase-requests/configuration/poNumber'
  static getCurrentPoNumberConfigurationMethod = 'GET'
  /**
   * No description
   *
   * @tags api-purchase-requests-number-configuration-controller
   * @name UpdateCurrentPoNumberConfiguration
   * @request POST:/api/v1/purchase-requests/configuration/poNumber
   */
  updateCurrentPoNumberConfiguration = (
    data: PurchaseRequestPoNumberConfigurationRequest,
    params: RequestParams = {},
  ) =>
    this.http.request<PurchaseRequestPoNumberConfigurationDto, any>({
      path: `/v1/purchase-requests/configuration/poNumber`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    })

  static updateCurrentPoNumberConfigurationPath = '/v1/purchase-requests/configuration/poNumber'
  static updateCurrentPoNumberConfigurationMethod = 'POST'
  /**
   * No description
   *
   * @tags api-purchase-requests-number-configuration-controller
   * @name GetPoNumberConfigurationHistory
   * @request GET:/api/v1/purchase-requests/configuration/poNumberHistory
   */
  getPoNumberConfigurationHistory = (params: RequestParams = {}) =>
    this.http.request<PurchaseRequestPoNumberConfigurationDto[], any>({
      path: `/v1/purchase-requests/configuration/poNumberHistory`,
      method: 'GET',
      format: 'json',
      ...params,
    })

  static getPoNumberConfigurationHistoryPath = '/v1/purchase-requests/configuration/poNumberHistory'
  static getPoNumberConfigurationHistoryMethod = 'GET'
}
